import React from "react"

import { DuplicateProjectOverlayView } from "./DuplicateProjectOverlayView"
import { useDuplicateProjectOverlayViewModel } from "./hooks/useDuplicateProjectOverlayViewModel"

export interface DuplicateProjectOverlayPayload {
  projectID: string
}

export interface DuplicateProjectOverlayProps {
  payload: DuplicateProjectOverlayPayload
}

export const DuplicateProjectOverlay = React.memo(
  (props: DuplicateProjectOverlayProps) => (
    <DuplicateProjectOverlayView
      {...useDuplicateProjectOverlayViewModel(props)}
    />
  )
)

declare module "shared/context/overlay/registry" {
  interface OverlayPayloadRegistry {
    DUPLICATE_PROJECT_OVERLAY: DuplicateProjectOverlayPayload
  }
}
